import template from "./label.hbs";
export class LabelElement extends HTMLElement {
    private _shadowRoot: ShadowRoot;

    constructor() {
        super();
        this._shadowRoot = this.attachShadow({ mode: "open" });
        let text = template({
            labelKey: this.getAttribute("label"),
            for: this.getAttribute("for"),
        });
        this._shadowRoot.innerHTML = text;
        this._shadowRoot.addEventListener("click", this.tapHandler);
    }

    set required(required: boolean) {
        const classList = this._shadowRoot.querySelector("label").classList;
        if (required) {
            classList.add("is-required");
        } else {
            classList.remove("is-required");
        }
    }
    private _findTarget = (): HTMLElement => {
        // external target
        return document.querySelector("#" + this.getAttribute("for"));
    }

    private tapHandler = (ev) => {
        const targetElement = this._findTarget();
        if (!targetElement) {
            return;
        }
        targetElement.focus();
        targetElement.click();
    }

}

export function initLabelWebComponent() {
    window.customElements.define("s6-input-label", LabelElement);
}
